export default __webpack_public_path__ + "static/media/photo6.e56e0c3f.jpg";